export const toDisplayDate = (date: string) => {
  const dateObj = new Date(date)

  if (isNaN(dateObj.getTime())) {
    return 'No disponible'
  }

  return dateObj.toLocaleString()
}

export const formatTimeAgo = (
  input: string | number | Date | null | undefined,
  locale: string = 'es',
): string => {
  if (!input) return 'No disponible'
  const date = new Date(input)
  if (isNaN(date.getTime())) return 'No disponible'

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  let diffInSeconds = Math.round((date.getTime() - Date.now()) / 1000)

  const divisions: Array<{
    amount: number
    unit: Intl.RelativeTimeFormatUnit
  }> = [
    { amount: 60, unit: 'second' },
    { amount: 60, unit: 'minute' },
    { amount: 24, unit: 'hour' },
    { amount: 30, unit: 'day' },
    { amount: 12, unit: 'month' },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' },
  ]

  let unit: Intl.RelativeTimeFormatUnit = 'second'
  let value = diffInSeconds

  for (const division of divisions) {
    if (Math.abs(value) < division.amount) {
      unit = division.unit
      break
    }
    value = Math.trunc(value / division.amount)
  }

  return rtf.format(value, unit)
}

export const sanitizeDatetime = (dateString: string | undefined): string => {
  if (!dateString) return new Date().toISOString()

  // Handle browser quirks like "202500-07-07T10:00" by keeping only first 4 digits of year
  const sanitized = dateString.replace(
    /^(\d{4})\d+(-\d{2}-\d{2}T\d{2}:\d{2})/,
    '$1$2',
  )
  const date = new Date(sanitized)

  // If date is invalid, use current date as fallback
  return isNaN(date.getTime()) ? new Date().toISOString() : date.toISOString()
}
